var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 29.3334H19.9998C26.6665 29.3334 29.3332 26.6667 29.3332 20.0001V12.0001C29.3332 5.33341 26.6665 2.66675 19.9998 2.66675H11.9998C5.33317 2.66675 2.6665 5.33341 2.6665 12.0001V20.0001C2.6665 26.6667 5.33317 29.3334 11.9998 29.3334Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1348 14.5467C19.0685 15.0027 18.9028 15.4385 18.6493 15.8233C18.3959 16.2081 18.0609 16.5324 17.6681 16.7734V19.4134C17.6681 19.8554 17.4925 20.2793 17.18 20.5919C16.8674 20.9044 16.4435 21.08 16.0015 21.08C15.5594 21.08 15.1355 20.9044 14.823 20.5919C14.5104 20.2793 14.3348 19.8554 14.3348 19.4134V16.7734C13.9421 16.5324 13.6071 16.2081 13.3536 15.8233C13.1002 15.4385 12.9344 15.0027 12.8681 14.5467C12.841 14.3926 12.8276 14.2365 12.8281 14.08C12.8299 13.5916 12.9445 13.1102 13.163 12.6733C13.3815 12.2365 13.698 11.8561 14.0878 11.5618C14.4776 11.2675 14.9302 11.0673 15.4102 10.9768C15.8902 10.8863 16.3846 10.9079 16.8548 11.04C17.3849 11.1835 17.8682 11.4634 18.2565 11.8517C18.6448 12.24 18.9247 12.7233 19.0681 13.2534C19.1825 13.6748 19.2053 14.1158 19.1348 14.5467V14.5467Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3362 14.5466H19.1362",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8665 14.5466H2.6665",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount2);
export default __webpack_public_path__ + "static/media/Account-2.a61eaa8e.svg";
export { ForwardRef as ReactComponent };